// const urls = "http://192.168.11.197:8080/nao-personal";
// const urlApi = 'http://192.168.11.197:8080/nao-doctor/api';//职业
// const urlReport = 'http://192.168.11.197:8080/nao-doctor';//报告单

const urls = "http://cp.66nao.com/nao-personal";
const urlApi = 'http://njc.66nao.com/nao-doctor/api';//职业
const urlReport = 'http://njc.66nao.com/nao-doctor';//报告单
export default {
	urltest: urls,
	urlApi:urlApi,
	urlReport:urlReport
}    



// WEBPACK FOOTER //
// ./src/scripts/urls.js